import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { getPaymentDeductionGroupStatus } from 'Utils/getPaymentStatus';

interface IGroupStatus {
  groupStatus: number;
  deductionType?: string;
}

export const GroupStatus = ({
  groupStatus,
  deductionType: dedactionType,
}: IGroupStatus) => {
  const status = getPaymentDeductionGroupStatus(
    groupStatus,
    Dictionary[DICTIONARY.PaymentsDeductions].paymentDeductionCard.groupStatus
  );

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap='9px'
      width='fit-content'
      padding='8px 0'
    >
      <Avatar
        alt=''
        src={status.image}
        sx={{ width: '15px', height: '15px' }}
      />
      <Typography variant={'body5'}>
        {dedactionType ? `${status.text} (${dedactionType})` : status.text}
      </Typography>
    </Stack>
  );
};
